import React, { useState } from "react";

import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";

import ProductViewModal from "./ProductViewModal";

import { imageURLs } from "../../../../setup/imageURLs";


const Product = (props) =>{
    const { product, handleQuantityChange, updateCartItems, materialBrands, materialCategories } = props
    const {relatedCartItem, eachProduct} = product

    const [isProductView, setIsProductView] = useState(false)

    const materialImages = eachProduct.materialImage?.length > 0 ? eachProduct.materialImage : ["https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image.png"]
    const materialImagesObjs = materialImages?.map(imageUrl => ({
        itemImageSrc: imageUrl,
    }))

    const materialImage = eachProduct.materialImage?.length > 0 ? eachProduct.materialImage[0] : imageURLs["NO_IMAGE_PATH"]

    const productName = eachProduct.companyProdName ? eachProduct.companyProdName : eachProduct.productName
    const productSpecification = eachProduct.companyProdSpec ? eachProduct.companyProdSpec : eachProduct?.productSpecification

    return (
        <>
            <div className="buyer-portal-product-card-container">
                <div className="mt-4" style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                    <div className="product-box-3 h-100 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="product-header" style={{height: "130px"}}>
                            <div className="product-image" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <img src={materialImage} className="product-card-img" style={{maxHeight: "120px", width: "auto", maxWidth: "180px" }} alt=""></img>
                                <ul className="product-option" style={{width: '40%', justifyContent: 'center'}}>
                                    <li className="flex justify-content-center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => { setIsProductView(true) }}
                                    >
                                        <Tooltip target="#target-view-icon"  content="View" position="top" />
                                        <i className="fa fa-eye"
                                            id="target-view-icon"> 
                                        </i>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="product-footer">
                            <div className="product-detail buyer-portal-card-content">
                                <h5 className="mb-1 name" maxLength={20}>{productName}</h5>
                                <div className='product-specification' style={{ marginTop: '0px' }}>
                                    <div className="span-name product-description">{productSpecification}</div>
                                </div>
                                { eachProduct.companyERPCode ? 
                                    <h6 className="mt-3 mb-1 unit">
                                        <span className="erp">ERP:&nbsp;</span><span>{eachProduct.companyERPCode}</span>
                                    </h6> : null 
                                }
                                <p className="my-1 unit">
                                    <span className="po">PO No:&nbsp;</span><span>{eachProduct.docNo}</span>
                                </p>
                                <p className="my-1 unit">
                                    <span className="po">Available Qty:&nbsp;</span><span>{eachProduct.availableQty}/{eachProduct.bPOQty} {eachProduct.UOMValue && eachProduct.UOMValue != 1 ? eachProduct.UOMValue : null} {eachProduct.UOM}</span>
                                </p>

                                <div className="flex justify-content-between">
                                    <p className="my-2 price">
                                        <span className="theme-color">&#8377; {eachProduct.bPOUnitPrice}</span>
                                    </p>
                                </div>

                                <div className="add-to-cart-box bg-white">
                                    {!relatedCartItem || (relatedCartItem && relatedCartItem.quantity === 0) ?
                                        <button className="btn btn-add-cart addcart-button" onClick={() => updateCartItems("ADD", eachProduct)} >Add
                                            <span className="add-icon bg-light-gray">
                                                <i className="fa-solid fa-plus"></i>
                                            </span>
                                        </button>
                                        :
                                        <>
                                            <button className="btn btn-add-cart addcart-button">Add
                                                <span className="add-icon bg-light-gray">
                                                    <i className="fa-solid fa-plus"></i>
                                                </span>
                                            </button>
                                            <div className="cart_qty qty-box">
                                                <div className="input-group flex bg-white">
                                                    <button type="button" className="qty-left-minus bg-gray"
                                                        data-type="minus" data-field="" onClick={() => updateCartItems("DECREASE", relatedCartItem)} >
                                                        <i className="fa fa-minus"></i>
                                                    </button>
                                                    <input
                                                        className="form-control input-number qty-input"
                                                        type="text"
                                                        name="quantity"
                                                        placeholder="Quantity"
                                                        value={relatedCartItem.quantity}
                                                        onChange={(e) => handleQuantityChange(e, relatedCartItem)}
                                                        onBlur={() => updateCartItems("SET", relatedCartItem)}
                                                    >
                                                    </input>
                                                    <button type="button" className="qty-right-plus bg-gray"
                                                        data-type="plus" data-field="" onClick={() => updateCartItems("INCREASE", relatedCartItem)}>
                                                        <i className="fa fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog className="product-view-dialog" visible={isProductView} style={{ width: "55%", minHeight: "50%" }} onHide={() => { setIsProductView(false) }} >
                    <ProductViewModal 
                        product={product}
                        materialBrands={materialBrands}
                        materialCategories={materialCategories}
                        updateCartItems={updateCartItems}
                        handleQuantityChange={handleQuantityChange}
                    />
                </Dialog>

            </div>
        </>
    )
}

export default Product;